import {fetchGet} from "../libs/reqCommon";
import {platformChineseFun} from '../libs/filterall';

const state={
    dataTime:[],
    lowTableData:[],
    seriesData:[],
    lowPriceList:[]
}
const getters={

}
const mutations={
    changeDataTime(state,params){
        state.dataTime=params
    },
    deleteDateTime(state,params){
       state.dataTime.splice(params,1)
    },
    changelowTableData(state,params){
        state.lowTableData=params
    },
    changeseriesData(state,params){
        state.seriesData=params
    },
    changelowPriceList(state,params){
        state.lowPriceList=params
    }
}
const actions={
     reqshopLowPriceLinkCount( { commit }, params){
        return new Promise((r, j) => {
             fetchGet("/hcm/iprViolationRetrieveData/shopLowPriceLinkCount", params).then(res => {
                if (res.status === "10000") {
                    commit('changelowTableData',res.data.content)

                    r(res.data.totalElements)
                }
            });
            })
     },
     reqlowPrice( { commit }, params){
         return new Promise((r,j)=>{
            fetchGet("/hcm/iprViolationRetrieveData/dailyLowPriceView", params).then(res=>{
                if(res.status === "10000"){

                  // console.log('res.data')
                  // console.log('res.data')
                  // console.log(res.data)
                  // console.log('res.data')
                  //图表
                  let seriesData={
                    series : [
                        {
                            name:'授权',
                            type:'bar',
                            barWidth : 20,
                            stack: '搜索引擎',
                            data:[]
                        },
                        {
                            name:'灰名单',
                            type:'bar',
                            stack: '搜索引擎',
                            data:[]
                        },
                        {
                            name:'黑名单',
                            type:'bar',
                            stack: '搜索引擎',
                            data:[]
                        },
                    ],
                     xAxisData:[],
                     legendData:['授权','灰名单','黑名单']
                  }
                  let arr=[
                    {platformCode:'',shoptype:'授权',whiteCount:0, whitePre:0 },
                    {platformCode:'',shoptype:'灰名单',grayCount:0, grayPre:0 },
                    {platformCode:'',shoptype:'黑名单',blackCount:0, otherPre:0 },
                  ]

                  res.data.forEach((item,index) => {
                    seriesData.xAxisData.push(platformChineseFun(item.platformCode))
                    item.dailyLowPriceData.forEach(items=>{
                      // console.log(items)
                      // console.log(seriesData.series)
                      if(items.shoptype==='授权店铺'){
                        console.log(items)
                        console.log(seriesData.series[0].data[index])
                        arr[0]=items;
                        // seriesData.series[0].data[index] = 0
                        if(!seriesData.series[0].data[index]){
                          seriesData.series[0].data[index]=items.whitecount;
                        }else{
                          seriesData.series[0].data[index]+=items.whitecount;
                        }
                      }
                      if(items.shoptype==='灰名单'){
                        arr[1]=items;
                        if(!seriesData.series[1].data[index]){
                          seriesData.series[1].data[index]=items.graycount;
                        }else{
                          seriesData.series[1].data[index]+=items.graycount;
                        }
                      }
                      if(items.shoptype==='黑名单'){
                        arr[2]=items;
                        if(!seriesData.series[2].data[index]){
                          seriesData.series[2].data[index]=items.blackcount;
                        }else{
                          seriesData.series[2].data[index]+=items.blackcount;
                        }
                      }

                    })
                    arr.forEach((itemss)=>{
                      //各个平台授权店铺数量总和
                      itemss.platformCode=item.platformCode
                    })
                    // console.log(arr)
                    item.dailyLowPriceData=JSON.parse(JSON.stringify(arr))
                    // console.log(item.dailyLowPriceData)
                  });
                  // console.log(res.data)
                  commit('changelowPriceList',res.data)
                  commit('changeseriesData',seriesData)
                  r(res.data)
                }

            })
         })

     }

}
export default {
    state,
    getters,
    mutations,
    actions
}
